<template src="./Descriptions.html"></template>

<script>
import topMenu from '@/components/brand/components/topMenu';
import {createNamespacedHelpers} from 'vuex';

const {mapGetters, mapActions} = createNamespacedHelpers('brand/info')

export default {
  name: "brandDescriptions",
  components: {
    topMenu,
  },
  data() {
    return {
      brandId: this.$route.params.id,
      showOverlay: 0,
    }
  },
  methods: {
    ...mapActions([
      'GET_INFO',
      'GET_GROUPS',
      'GET_COUNTRIES',
      'GET_BRANDS',
      'GET_COMMENTS',
      'SAVE',
    ]),
  },
  computed: {
    ...mapGetters([
      'BRAND',
      'IS_SEND_ALREADY'
    ]),
  },
  watch: {
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('brand') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.initPageSize();
  },
  created() {
    if (this.IS_SEND_ALREADY != this.brandId) {
      this.GET_INFO({id: this.brandId, th: this});
      this.GET_GROUPS({th: this});
      this.GET_COUNTRIES({th: this});
      this.GET_BRANDS({th: this});
      this.GET_COMMENTS({brandId: this.brandId, th: this});
      this.$store.commit('brand/info/IS_SEND_ALREADY', this.brandId);
    }
  }
}
</script>

<style scoped>
.region-row {
  font-weight: bold;
}
.text-align-right {
  text-align: right;
}
</style>

<style>

</style>